import { EMPTY_FIELD } from 'constants/emptyField';

import {
  DEFAULT_DATE_MASK,
  DEFAULT_SEPARATOR,
  DEFAULT_TIMEZONE,
} from 'shared/mui/DatePicker/config/defaultValues';

import { formatInputInTz } from './formatInputInTz';

type OptionsType = { format?: string; timezone?: string | null; placeholder?: string };
/**
 * Форматирует диапазон дат в строку с учётом таймзоны.
 *
 * Каждое значение форматируется через formatInputInTz.
 * Если одна из дат отсутствует — возвращается placeholder.
 *
 * @example
 * formatRangeInputInTz(
 *   ['2024-01-01T00:00:00Z', '2024-01-02T00:00:00Z'],
 *   { timezone: 'Europe/Moscow' }
 * )
 * // → "01.01.2024 - 02.01.2024"
 */
export function formatRangeInputInTz(
  range: [unknown, unknown],
  {
    timezone = DEFAULT_TIMEZONE,
    format = DEFAULT_DATE_MASK,
    placeholder = EMPTY_FIELD,
  }: OptionsType = {},
): string {
  const [start, end] = range;

  const formatValue = (value: unknown) => formatInputInTz(value, { timezone, format });

  if (!start || !end) {
    return placeholder;
  }

  return `${formatValue(start)}${DEFAULT_SEPARATOR}${formatValue(end)}`;
}
